/**
 * O nome vem como a pessoa digitou no cadastro: "RAPHAEL", "raphael" ou
 * "  raphael silva". A tela mostra sempre "Raphael".
 */
export function primeiroNome(nome: string | null | undefined): string | null {
  const primeiro = nome?.trim().split(/\s+/)[0];
  if (!primeiro) return null;
  return primeiro.charAt(0).toLocaleUpperCase('pt-BR') + primeiro.slice(1).toLocaleLowerCase('pt-BR');
}

/** Preposições ficam minúsculas: "RAPHAEL DE SOUZA" → "Raphael de Souza". */
const MINUSCULAS = new Set(['de', 'da', 'do', 'das', 'dos', 'e']);

/** Nome completo com cada palavra capitalizada, como num documento. */
export function nomeFormatado(nome: string | null | undefined): string {
  return (nome ?? '')
    .trim()
    .split(/\s+/)
    .map((palavra, indice) => {
      const minuscula = palavra.toLocaleLowerCase('pt-BR');
      if (indice > 0 && MINUSCULAS.has(minuscula)) return minuscula;
      return minuscula.charAt(0).toLocaleUpperCase('pt-BR') + minuscula.slice(1);
    })
    .join(' ');
}

/** Letra do ícone de perfil. Sem nome, um marcador neutro. */
export function inicial(nome: string | null | undefined): string {
  return primeiroNome(nome)?.charAt(0) ?? '•';
}
